module.exports = __webpack_public_path__ + "static/media/rowboat.b2ae94cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rowboat.png
// module id = 582
// module chunks = 0